import { PreguntasTipoEnum } from "@shared/enums";
import { PreguntaImportador } from "../PreguntaImportador";

export class PreguntaFlowJumpImportador extends PreguntaImportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.FLOW_JUMP;
    }
}
